<template>
  <grid-layout
    @layout-updated="onUpdatedLayout"
    :layout="widgetItems"
    :col-num="12"
    :row-height="30"
    :is-draggable="checkIsMobile() ? false : true"
    :is-resizable="true"
    :vertical-compact="true"
    :margin="[10, 10]"
    :responsive="true"
    :breakpoints="breakpoints"
    :cols="cols"
    :auto-size="true"
    :use-css-transforms="true">

    <grid-item v-for="item in widgetItems"
      @resize="onResize"
      :isResizable="checkResizableWidget(item.name)"
      :key="item.i"
      :class="`widget__holder ${item.name}_${item.i}`"
      :dragAllowFrom="'.widget__header'"
      :dragIgnoreFrom="'.widget__main-menu'"
      :minH="item.minH"
      :minW="item.minW"
      :i="item.i"
      :w="item.w"
      :h="item.h"
      :y="getYResponsive(item)"
      :x="item.x">
      <div class="widget__header">
        <i :class="item.iconClass || 'fa fa-bar-chart'"></i>
        <span class="widget__title">
          {{ setTitle(item.title) }}
        </span>
        <div class="widget__main-menu pull-right">
          <i
            title="Delete Widget"
            @click="deleteWidgetId = item.i"
            v-b-modal.delete_widget
            class="fa fa-trash widget__button widget--delete"></i>
          <i
            title="Edit Widget"
            @click="editWidget(item)"
            class="fa fa-edit widget__button widget--edit"></i>
        </div>
      </div>
      <div class="widget__body">
        <DailyShipments
          v-if="item.name === 'daily_shipments'"
          :range="item.date_range"
          :startDate="item.start_date"
          :endDate="item.end_date" />

        <DailyOrders
          v-if="item.name === 'daily_orders'"
          :range="item.date_range"
          :startDate="item.start_date"
          :endDate="item.end_date" />

        <ShipmentByState
          v-if="item.name === 'shipment_by_state'"
          :range="item.date_range"
          :startDate="item.start_date"
          :endDate="item.end_date" />

        <!-- <ShipmentCompletion
          v-if="item.name === 'completion_items'"
          :widgetIndex="item.i" /> -->

        <VehicleStatus
          v-if="item.name === 'vehicle_status'"
          :geofences="item.geofences"
          :widgetIndex="item.i"/>

        <OrdersCancelation
          v-if="item.name === 'orders_cancelation'"
          :range="item.date_range"
          :startDate="item.start_date"
          :endDate="item.end_date"
          :widgetIndex="item.i"/>
      </div>
    </grid-item>
    <div>
      <b-modal
        id="delete_widget"
        title="Delete Widget"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="removeWidget(deleteWidgetId)">
        <p class="my-4">Are you sure want to delete this widget ?</p>
      </b-modal>
    </div>
  </grid-layout>
</template>
<script>
import { findIndex, find, get } from 'lodash';
import { GridLayout, GridItem } from 'vue-grid-layout';
import DailyShipments from '@/components/dashboard_widgets/DailyShipments';
import DailyOrders from '@/components/dashboard_widgets/DailyOrders';
import ShipmentByState from '@/components/dashboard_widgets/ShipmentByState';
import CompletionItems from '@/components/dashboard_widgets/CompletionItems';
import ShipmentCompletion from '@/components/dashboard_widgets/shipment_completion/Index';
import VehicleStatus from '@/components/dashboard_widgets/VehicleStatus';
import OrdersCancelation from '@/components/dashboard_widgets/OrdersCancelation';

export default {
  name: 'dashboard-widget',
  components: {
    GridLayout,
    GridItem,
    DailyShipments,
    DailyOrders,
    ShipmentByState,
    CompletionItems,
    ShipmentCompletion,
    VehicleStatus,
    OrdersCancelation,
  },
  data() {
    return {
      deleteWidgetId: null,
      resizableWidgets: ['completion_items'],
    };
  },
  props: {
    widgetItems: {
      type: Array,
      default: [],
      require: true,
    },
    breakpoints: {
      type: Object,
      default: {},
      require: true,
    },
    cols: {
      type: Object,
      default: {},
      require: true,
    },
  },
  methods: {
    setTitle(title) {
      return title === '' ? 'Widget' : title;
    },
    removeWidget(id) {
      const targetWidget = findIndex(this.widgetItems, { i: id });
      this.widgetItems.splice(targetWidget, 1);
      this.onUpdatedLayout(this.widgetItems);
    },
    editWidget(item) {
      this.$emit('on-edit-widget', item);
    },
    onUpdatedLayout(newLayout) {
      this.$emit('on-updated-layout', newLayout);
    },
    checkResizableWidget(widgetName) {
      return this.resizableWidgets.indexOf(widgetName) > -1;
    },
    onResize(i) {
      const wg = find(this.widgetItems, { i });
      const { name: wgName } = wg;
      const wgContainerNode = document.querySelector(`.${wgName}_${i}`);

      if (wgName === 'completion_items') {
        const wgContentNode = document.querySelector(`.completion_${i}`);
        const list = wgContentNode.getElementsByClassName('completion__list');
        const loading = wgContentNode.getElementsByClassName('loading');
        list[0].style.display = 'none';
        loading[0].style.display = 'block';

        setTimeout(() => {
          wgContentNode.style.maxHeight = `${wgContainerNode.clientHeight}px`;
          wgContentNode.style.height = `${wgContainerNode.clientHeight - 48}px`;
          list[0].style.display = 'block';
          loading[0].style.display = 'none';
        }, 1e3);
      }
    },
    checkIsMobile() {
      const widthLayout = get(document.getElementsByClassName('dashboard__main-menu'), '0.clientWidth') || 0;
      const isMobile = widthLayout < this.breakpoints.md;
      return isMobile;
    },
    getYResponsive(item) {
      if (this.checkIsMobile()) {
        const hasMobileY = Object.prototype.hasOwnProperty.call(item, 'y_m');
        return hasMobileY ? item.y_m : item.y;
      }
      return item.y;
    },
  },
};
</script>
<style lang="sass" scoped>
.card-body
  padding: 0.25rem !important;

.widget__main-menu
  .widget__button
    cursor: pointer;

.widget__title
  font-weight: bold;
  position: absolute;
  margin-left: 5px;

.widget__holder:hover
  box-shadow: 1px 1px 38px -8px #8e8c8e;

.widget__holder
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #c2cfd6;
  border-radius: 0.25rem

.widget__header
  padding: 0.75rem 1.25rem 0.75rem 0.75rem;
  height: 40px;
  margin-bottom: 0;
  background-color: #f0f3f5;
  border-bottom: 1px solid #c2cfd6;
  border-radius: 0.25rem 0.25rem 0 0;
  cursor: move;

.widget__main-menu
  .widget__button
    font-size: 15px;

.widget__main-menu
  .widget--delete
    color: #fd3b3b;
    font-size: 16px !important;
    margin-right: 3px;

.widget__main-menu
  transition: all 1s ease-out;
  opacity: 0;

.widget__holder:hover
  .widget__main-menu
    transition: all 1s ease-in;
    opacity: 1;
</style>



// WEBPACK FOOTER //
// src/views/pages/dashboard/Widget.vue